var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,0.5c-7.9,0-14.4,6.4-14.4,14.3c0,5,2.6,9.7,6.9,12.3C8,30.4,2.4,38.4,2.4,47.5H6c0-8.6,6-16,14.4-17.7V33l3.6,3.6 l3.6-3.6v-3.2C36,31.5,42,38.9,42,47.5h3.6c0-9-5.6-17.1-14-20.2c6.8-4.2,8.9-13,4.7-19.8C33.7,3.1,29,0.5,24,0.5z M24,36.6 l-3.6,3.6v7.2h7.2v-7.2L24,36.6z M24,4.2C30,4.2,34.8,9,34.8,15c0,6-4.8,10.8-10.8,10.8c-6,0-10.8-4.8-10.8-10.8 C13.2,9,18,4.2,24,4.2C24,4.2,24,4.2,24,4.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManager);
export default __webpack_public_path__ + "static/media/Manager.48b1c5a80f357c1a026a8cf62f454616.svg";
export { ForwardRef as ReactComponent };